import React from "react";
import GoogleMapReact from "google-map-react";
const mapStyles = {
  width: "100%",
  height: "100%",
};
const AnyReactComponent = ({ text }) => (
  <div>
    <img src="/public/assets/icons/looocatiohn.svg" alt="pic"/>
  </div>
);
class myRequestOrdersDetailsMap extends React.Component {
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 11,
  };

  render() {
    return (
      <>
        <div style={{ height: "100vh", width: "100%" }}>
          <GoogleMapReact
            // bootstrapURLKeys={{ key: /* YOUR KEY HERE */ }}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
          >
            <AnyReactComponent
              lat={59.955413}
              lng={30.337844}
              text="My Marker"
            />
          </GoogleMapReact>
        </div>
      </>
    );
  }
}
export default myRequestOrdersDetailsMap;
